<template>
  <div class="multiple_choice_one">
    <h5 v-html="question.the_question"></h5>

    <div v-show="show_all" v-if="response">
      <div class="custom-control custom-radio" v-for="answer in questionAnswers" :key="answer.id">
        <input class="custom-control-input" type="radio" :checked="checked(answer.id)" />
        <div class="custom-control-label" v-if="answer && answer.freeform">
          {{ response.text_answer }}
        </div>
        <div class="custom-control-label" v-else>
          {{ answer.the_answer }}
        </div>
      </div>
      <div class="whisper" v-if="chosen_answer && chosen_answer.freeform">
        This is a freeform answer
      </div>
    </div>

    <div v-show="!show_all">
      <div v-if="chosen_answer">
        <div class="custom-control custom-radio">
          <input class="custom-control-input" type="radio" checked />
          <div class="custom-control-label" v-if="chosen_answer.freeform">
            {{ response.text_answer }}
          </div>
          <div class="custom-control-label" v-else>
            {{ chosen_answer.the_answer }}
          </div>
        </div>
        <div class="whisper" v-if="chosen_answer.freeform">This is a freeform answer</div>
      </div>
      <div class="whisper" v-else>No response yet</div>
    </div>
  </div>
</template>

<script lang="ts">
import { mapState } from 'pinia'
import { useAnswerStore } from '@app/stores/AnswerStore.ts'
import { useSurveyResponseStore } from '@app/stores/SurveyResponseStore.ts'

export default {
  props: ['question', 'recipient_id', 'show_all'],
  computed: {
    ...mapState(useSurveyResponseStore, ['surveyResponses']),
    ...mapState(useAnswerStore, ['answers']),
    response() {
      return this.surveyResponses.find(
        (r) => r.question_id === this.question.id && r.recipient_id === Number(this.recipient_id),
      )
    },
    chosen_answer() {
      return this.questionAnswers.find((a) => a.id === this.response?.answer_id)
    },
    questionAnswers() {
      return this.answers.filter((a) => a.question_id === this.question.id)
    },
  },
  methods: {
    checked(answer_id) {
      return this.surveyResponses.some(
        (r) => r.answer_id === answer_id && r.recipient_id === Number(this.recipient_id),
      )
    },
  },
}
</script>
<style lang="sass" scoped>
h5
  line-height: 140%
  margin-bottom: 16px
.custom-control
  margin-bottom: 12px
.question:hover
  border: 1px solid white !important
</style>
